export default __webpack_public_path__ + "static/Plots0001-7f41885b365c8da10fdd0bcec1a5c15f.jpg";